import React from 'react';

import { useIntl } from 'react-intl';

import PageIcon from '@atlaskit/icon/core/page';

import { AdditionalNoteBase } from './AdditionalNoteBase';
import { messages } from './messages';

export const UpdateNoteField = ({
	updateNote,
}: {
	updateNote?: { summary?: string; description: string };
}): React.JSX.Element => {
	const intl = useIntl();
	return (
		<AdditionalNoteBase
			icon={<PageIcon size="medium" label="" />}
			title={updateNote?.summary ?? intl.formatMessage(messages.moreDetail)}
			description={updateNote?.description}
			testId="project-status-update-action-renderer.ui.update-note"
		/>
	);
};
